/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const dataProtectionOfficerDataSchema = z.object({
	name: z.string().nullable().optional(),
	phoneNumber: z.string().nullable().optional(),
	emailAddress: z.string().email().nullable().optional(),
})

export type DataProtectionOfficerDataSchema = z.infer<typeof dataProtectionOfficerDataSchema>
